import * as Yup from 'yup'
import {parseMomentFromLocalDateTimeField} from 'utils/date'
import moment from 'moment'

export const dateTime = () =>
  Yup.string()
    .test(
      'date-time',
      'form.validation.date',
      value => {
        if (value) {
          return parseMomentFromLocalDateTimeField(value).isValid()
        }
        return true
      }
    )

export const time = () => Yup.string()
  .test('time', 'form.validation.time', value => {
    if (!value) {
      return true
    }
    const parsed = moment(value, ['h:mm', 'H:mm'], true)
    return parsed.isValid()
  })
  .required('form.validation.required')

export const currencySchema = Yup.string()
  .matches('^[A-Z]{3}$', 'form.validation.currencyCode')
  .required('form.validation.required')
export const amountSchema = Yup.number()
    .min(0)
    .max(1000000000)
    .required('form.validation.required')

export const priceSchema = Yup.object({
  amount: amountSchema,
  currencyCode: currencySchema
})
